<template>
  <div>
    <div
      class="sub-header"
      data-test="sub-header"
    >
      Fundraiser Story
    </div>
    <div
      class="overflow-y-scroll scrollbar modal-height"
      data-test="scroll-container"
    >
      <h5
        style="padding-bottom: 24px"
        class="inputs text-center md:text-left"
        data-test="description"
      >
        Write a bit about why this particular organization’s goals matter to you. A compelling fundraiser story can
        inspire more generosity for your chosen cause!
      </h5>
      <div class="flex flex-col">
        <Textarea
          :style="{ width: isMobile ? '100%' : '430px', fontSize: '1rem' }"
          :placeholder="'Placeholder Text'"
          :value="fundraiserStore.story"
          :class="{ 'p-invalid': fundraiserStore.errors.story }"
          data-test="fundraiser-story-input"
          id="textArea"
          :maxlength="1000"
          rows="5"
          autoResize
          @input="
            (e) => {
              fundraiserStore.story = e.target.value;
              delete fundraiserStore.errors.story;
            }
          "
        />
        <small
          class="p-error"
          v-if="fundraiserStore.errors.story"
        >
          {{ fundraiserStore.errors.story }}
        </small>
        <small v-else> Character count {{ fundraiserStore.story.length }}/1000 </small>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useFundraiserStore } from '@/stores/FundraiserStore.js';
import useIsMobile from '@/composables/useIsMobile.js';

const { isMobile } = useIsMobile();

const fundraiserStore = useFundraiserStore();
</script>
